import { GetBalenaDeviceQuery, GetBalenaReleaseQuery } from '../balena_schemas'

export const getIsRunningReleaseId = (data: GetBalenaDeviceQuery | undefined): string | null => {
    const id = data?.devices?.[0]?.is_running__release?.__id
    return id ? id + '' : null
}

export const getShouldBeRunningReleaseId = (data: GetBalenaDeviceQuery | undefined): string | null => {
    const id = data?.devices?.[0]?.should_be_running__release?.__id
    return id ? id + '' : null
}

export function getSemver(response: GetBalenaReleaseQuery | undefined): string | undefined {
    return response?.releases?.[0]?.semver ?? undefined
}

export const getDeviceReleaseStatus = (data: GetBalenaDeviceQuery | undefined): string => {
    const device = data?.devices?.[0]
    if (!device) return 'UNKNOWN'

    const runningId = getIsRunningReleaseId(data)
    const targetId = getShouldBeRunningReleaseId(data)
    const updateStatus = device.update_status ?? null

    if (updateStatus === 'aborted') return 'UPDATE FAILED'

    switch (updateStatus) {
        case 'downloading':
            return 'UPDATING (DOWNLOADING)'
        case 'downloaded':
            return 'UPDATING (PENDING APPLY)'
        case 'applying_changes':
            return 'UPDATING (APPLYING CHANGES)'
    }

    if (!targetId) return 'UP-TO-DATE'
    if (!runningId) return 'UNKNOWN'
    if (runningId === targetId) return 'UP-TO-DATE'
    return 'UPDATE PENDING'
}
